import React from "react"
import { imageUrlFor } from "../../helpers/image-url"
import { buildImageObj } from "../../helpers/utils"
import { getImageDimensions } from "@sanity/asset-utils"

function Figure({ value }) {
  const { width, height } = getImageDimensions(value)
  console.log({ width, height })

  return (
    <figure className="w-100">
      {value && (
        <img
          src={imageUrlFor(buildImageObj(value))
            .width(1200)
            .auto("format")
            .url()}
          alt={value.alt}
          className="aspect-[1.5]"
          style={{
            aspectRatio: `${width / height}`,
          }}
        />
      )}
      <figcaption className="">{value.caption}</figcaption>
    </figure>
  )
}

export default Figure
